import * as go from 'gojs';
import { FREE_HAND_DRAWING_TOOL_NAME } from './config';
import { FreeHandDrawingTool } from './free-hand-drawing-tool';

const setupFreeHandDrawingTool = (diagram: go.Diagram) =>
  diagram.toolManager.mouseMoveTools.insertAt(2, new FreeHandDrawingTool());

const runFreeHandDrawingTool = (
  diagram: go.Diagram,
  shapeProperties: go.ObjectData,
  cursor: string,
  allowedClickClass: string,
  action: (position: go.Point, geoString: string) => void,
) => {
  const tool = diagram.toolManager.findTool(FREE_HAND_DRAWING_TOOL_NAME) as FreeHandDrawingTool;
  tool.cursor = cursor;
  tool.shapeProperties = shapeProperties;
  tool.allowedClickClass = allowedClickClass;
  if (tool) {
    tool.startManually(action);
  }
};

export const freeHandDrawingToolAPI = {
  setup: setupFreeHandDrawingTool,
  run: runFreeHandDrawingTool,
};
